export default "__VITE_ASSET__LN9xN$1L__"